import { useEffect, useState } from 'react';
import SearchPageContent from './SearchPageContent';

function SearchPage() {
  const [productHandles, setProductHandles] = useState(null);
  const urlSearchParams = new URLSearchParams(document.location.search);
  const searchTerm = urlSearchParams.get('search');

  useEffect(() => {
    const searchShopify = async (term) => {
      try {
        const options = { method: 'POST', body: JSON.stringify({ term }) };
        const request = await fetch(`/api/shopify/search`, options);
        const { response } = await request.json();
        const shopifyProducts = response?.results?.products || [];

        const searchProductHandles = shopifyProducts
          ?.filter((p) => !p.tags.includes('findify-remove'))
          ?.map((product) => product.handle);

        setProductHandles(searchProductHandles);
      } catch (e) {
        console.error('searchShopify:error', e);
        return [];
      }
    };

    if (searchTerm) {
      searchShopify(searchTerm);
    }
  }, []);

  return (
    <div>
      <div className="h3 px-5 lg:container lg:mx-auto">
        {searchTerm
          ? `All search results for "${searchTerm}"`
          : 'No search term specified'}
      </div>
      {productHandles && productHandles.length > 1 && (
        <SearchPageContent key={searchTerm} productHandles={productHandles} searchTerm={searchTerm} />
      )}
    </div>
  );
}

export default SearchPage;
